export default __webpack_public_path__ + "static/media/arrowback.037e7aeb.svg";